// extracted by mini-css-extract-plugin
export default {"wrap":"TenantGreeting_wrap__urCzN","dot":"TenantGreeting_dot__NuI1Q"};